module.exports = __webpack_public_path__ + "img/skycatchfire.bac98d08.svg";